// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1FT9L","additionalInfo":"AgreementModal_additionalInfo__19UsC"};